"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b)
                if (b.hasOwnProperty(p))
                    d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var fn = require("./fn");
var Right = /** @class */ (function () {
    function Right(r) {
        this.r = r;
    }
    Right.prototype.isLeft = function () {
        return false;
    };
    Right.prototype.isRight = function () {
        return true;
    };
    Right.prototype.map = function (f) {
        return new Right(f(this.r));
    };
    Right.prototype.lmap = function (f) {
        return new Right(this.r);
    };
    Right.prototype.flatMap = function (f) {
        return f(this.r);
    };
    Right.prototype.swap = function () {
        return new Left(this.r);
    };
    Right.prototype.left = function () {
        return new fn.None();
    };
    Right.prototype.right = function () {
        return new fn.Just(this.r);
    };
    Right.prototype.unwrap = function () {
        return this.r;
    };
    return Right;
}());
exports.Right = Right;
var UnwrapError = /** @class */ (function (_super) {
    __extends(UnwrapError, _super);
    function UnwrapError(source, message) {
        var _this = _super.call(this, message) || this;
        _this.source = source;
        return _this;
    }
    return UnwrapError;
}(Error));
exports.UnwrapError = UnwrapError;
var Left = /** @class */ (function () {
    function Left(l) {
        this.l = l;
    }
    Left.prototype.isLeft = function () {
        return true;
    };
    Left.prototype.isRight = function () {
        return false;
    };
    Left.prototype.map = function (f) {
        return new Left(this.l);
    };
    Left.prototype.lmap = function (f) {
        return new Left(f(this.l));
    };
    Left.prototype.flatMap = function (f) {
        return new Left(this.l);
    };
    Left.prototype.swap = function () {
        return new Right(this.l);
    };
    Left.prototype.left = function () {
        return new fn.Just(this.l);
    };
    Left.prototype.right = function () {
        return new fn.None();
    };
    Left.prototype.unwrap = function () {
        throw new UnwrapError(this.l, 'Attempted to unwrap() a Left. Check with isRight() first.');
    };
    return Left;
}());
exports.Left = Left;
function filterRight(eithers) {
    return fn.filterJust(eithers.map(function (e) { return e.right(); }));
}
exports.filterRight = filterRight;
function filterLeft(eithers) {
    return fn.filterJust(eithers.map(function (e) { return e.left(); }));
}
exports.filterLeft = filterLeft;
function left(l) {
    return new Left(l);
}
exports.left = left;
function right(r) {
    return new Right(r);
}
exports.right = right;
function try_(f) {
    try {
        return right(f());
    }
    catch (e) {
        return left(e);
    }
}
exports.try_ = try_;
function unwrap(p) {
    return p.then(function (e) { return e.unwrap(); });
}
exports.unwrap = unwrap;
